import ImageGalleryBlock from './ImageGalleryBlock';

export default ImageGalleryBlock;
